import { select, call, put } from "redux-saga/effects";
import { getMobileNumber } from "state/app/selectors";
import { getSchoolByID, getServerID } from "state/teachers/selectors";
import { addPendingReply, setPendingReplyStatus, fetchMessages } from "state/teachers/actions";
import { sendTeachersDataRequest } from "state/fetchSagas";

// Timeout for axios request before aborting (milliseconds)
const REQUEST_TIMEOUT = 60000;

// Matches the relevant line from the full response
function getGeneratedID() { return (+new Date()); }

export default function* sendReply(action) {

  // Generate an ID for the new pendingReply
  const { schoolID, body } = action.payload;
  
  // Create parameter map.
  const paramMap = {};
  paramMap.generatedID = getGeneratedID();
  paramMap.pendingReplyID = `${schoolID}:P:${paramMap.generatedID}`;
  paramMap.requestOptions = {timeout: REQUEST_TIMEOUT};
  paramMap.serverId = yield select(getServerID, schoolID);
  paramMap.mobileNumber = yield select(getMobileNumber);
  paramMap.school = yield select(getSchoolByID, schoolID);
  paramMap.requestArgs = { message: body, originator: paramMap.mobileNumber, school_id: paramMap.school.get("remoteID"), server_id: paramMap.serverId };
  paramMap.pendingReply = { id: paramMap.pendingReplyID, schoolID, body, status: "sending" };

  // Add the new pendingReply to state
  yield put(addPendingReply(paramMap.pendingReplyID, paramMap.pendingReply));

  // Call api endpoints, only one will process message reply.
  try {
    yield call(MessageReply, paramMap);
    yield put(setPendingReplyStatus(paramMap.pendingReplyID, "sent"));
    yield put(fetchMessages());  
  } catch (error) {
    yield put(setPendingReplyStatus(paramMap.pendingReplyID, "failed"));
  }

  // Messenger message reply uses AppServer.
  // response.data[0][4] is a JSON string, making it easy to pass a map of values within the legacy framework.
  function* MessageReply(paramMap){
    const response = yield call(sendTeachersDataRequest, "send_my_message_reply", paramMap.requestArgs, paramMap.requestOptions);
    
    // Catch endpoint communication issue.
    if(response.status === "error"){ 
      console.error(`Send reply error: ${response.message}`);
      throw new Error();
    }

    // Catch endpoint script error.
    const messageReplyResult = JSON.parse(response.data[0][4]);
    if(!messageReplyResult.isProcessed){ 
      console.error(`Send reply endpoint error: ${messageReplyResult.errorMessage}`); 
      throw new Error();
    }
  }
}


// WEBPACK FOOTER //
// ./src/state/teachers/sagas/sendReply.js